import { FolderPlus } from 'lucide-react';

const chipBase = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '6px 14px',
  borderRadius: 10,
  fontSize: 13,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

function chipClass(active, color) {
  if (active) {
    return {
      className: 'text-black font-bold',
      style: { background: color || '#fff' },
    };
  }
  return {
    className: 'bg-white/[0.04] text-white/60 border border-white/[0.08] hover:bg-white/[0.08]',
    style: undefined,
  };
}

export default function FolderChips({
  folders,
  flowsCount,
  folderCounts,
  noFolderCount,
  folderFilter,
  onFilterChange,
  onManageFolders,
}) {
  return (
    <div className="flex items-center gap-2 flex-wrap mb-6">
      {(() => {
        const chip = chipClass(folderFilter === 'all');
        return (
          <button
            type="button"
            style={{ ...chipBase, ...chip.style }}
            className={chip.className}
            onClick={() => onFilterChange('all')}
          >
            Todos ({flowsCount})
          </button>
        );
      })()}

      {folders.map(folder => {
        const chip = chipClass(folderFilter === folder.id, folder.color);
        return (
          <button
            key={folder.id}
            type="button"
            style={{ ...chipBase, ...chip.style }}
            className={chip.className}
            onClick={() => onFilterChange(folder.id)}
          >
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: folder.color, flexShrink: 0 }} />
            {folder.name} ({folderCounts[folder.id] || 0})
          </button>
        );
      })}

      {folders.length > 0 && (() => {
        const chip = chipClass(folderFilter === 'none');
        return (
          <button
            type="button"
            style={{ ...chipBase, ...chip.style }}
            className={chip.className}
            onClick={() => onFilterChange('none')}
          >
            Sem pasta ({noFolderCount})
          </button>
        );
      })()}

      <button
        type="button"
        style={{ ...chipBase, padding: '6px 10px' }}
        className={chipClass(false).className}
        title="Gerenciar pastas"
        onClick={onManageFolders}
      >
        <FolderPlus size={15} />
      </button>
    </div>
  );
}
